import '@banno/jha-wc/src/forms/jha-form-radio-button/jha-form-radio-button';
import '@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table';
import { InjectProperty } from '@jack-henry/frontend-utils/di';
import '@jack-henry/jh-ui/components/button/button.js';
import '@jack-henry/jh-ui/components/radio/radio.js';
import { NavigationService } from '@treasury/core/navigation';
import { CompanyUserService } from '@treasury/domain/company/user/company-user.service';
import { CompanyUserSummary } from '@treasury/domain/company/user/entities';
import { TmBaseComponent } from '@treasury/presentation';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

export const tagName = 'tm-bo-create-user-copy-user-drawer';

@customElement(tagName)
export class CopyUserDrawer extends TmBaseComponent {
    @property({ type: Number })
    public companyId?: number;

    @InjectProperty()
    declare private readonly navigationService: NavigationService;

    @InjectProperty()
    declare private readonly companyUserService: CompanyUserService;

    @state()
    private searchUsers: CompanyUserSummary[] = [];

    @state()
    private selectedCopyUser?: CompanyUserSummary;

    public render() {
        const columns = [
            {
                id: 'entityId',
                valueRenderer: (id: string, companyUserSummary: CompanyUserSummary) =>
                    html`<jha-form-radio-button
                        value=${id}
                        @click=${() => this.handleRadio(companyUserSummary)}
                        .checked=${this.selectedCopyUser?.entityId === id}
                    ></jha-form-radio-button>`,
            },
            { id: 'userName', label: 'User Name', searchable: true },
            { id: 'userId', label: 'User ID', searchable: true },
            {
                id: 'isAdmin',
                label: 'Role',
                valueRenderer: (_: string, item: CompanyUserSummary) => {
                    const roles: string[] = [];
                    if (item.isAdmin) {
                        roles.push('Admin');
                    }
                    if (item.isSuperUser) {
                        roles.push('Super User');
                    }

                    if (roles.length === 0) {
                        return nothing;
                    }

                    return html`<p>${roles.join(', ')}</p>`;
                },
            },
        ];

        return html`<jha-advanced-table
            .columns=${columns}
            .data=${this.searchUsers}
        ></jha-advanced-table>`;
    }

    protected async firstUpdated() {
        const { params } = await this.navigationService.getRouteData<{ companyId: string }>();
        this.companyId = parseInt(params.companyId);
        this.searchUsers = await this.companyUserService.searchCompanyUsers(this.companyId);
    }

    private handleRadio(companyUserSummary: CompanyUserSummary) {
        this.selectedCopyUser = companyUserSummary;
        this.dispatchEvent(new CustomEvent('copy-user-change', { detail: this.selectedCopyUser }));
    }
}
